export default {
    _prefix: "HelpButton",
    labels: {
        helpText: (data: { helpText: string }) =>
            `Question Help Text: {{helpText}}`,
    },
};
